export interface IGetJSON {
	getJSON(): any;
}

export function getAllowedEditorHtmlTags():string[]{
	return ["ul", "ol", "li", "b", "u", "i", "br", "blockquote", "hr", "span"];
}